module.exports = __webpack_public_path__ + "@/assets/img/bezier-curve.95e4bb9c.svg";